class CollectionPassword extends Theme.Component {
  connectedCallback() {
    super.connectedCallback();

    this.defineElements({
      form: '[data-password-form]',
      input: '[data-password-input]',
      error: '[data-password-error]'
    });

    this.password = this.dataset.password;
    this.storageKey = 'col_pw:' + this.dataset.collectionHandle;

    if (sessionStorage.getItem(this.storageKey) === this.password) {
      this.remove();
      return;
    }

    document.body.style.overflow = 'hidden';

    this.elements.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.submit();
    });
  }

  submit() {
    const value = this.elements.input.value.trim();

    if (value === this.password) {
      sessionStorage.setItem(this.storageKey, value);
      document.body.style.overflow = '';
      this.classList.add('collection-password--exiting');
      this.addEventListener('transitionend', () => this.remove(), { once: true });
      setTimeout(() => this.remove(), 500);
    } else {
      this.elements.error.style.display = 'block';
      this.elements.input.value = '';
      this.elements.input.focus();
    }
  }
}

customElements.define('collection-password', CollectionPassword);
